import * as __req_0 from "../../../assets/images/beer.svg";
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { push } from "connected-react-router";
import BeerCard from "./BeerCard/BeerCard";
import Spinner from "@common/components/Spinner/Spinner";
import { FormGroup, FormControl, Button, Modal } from "react-bootstrap";
import "./BeerList.scss";
import BeerModal from "../BeerModal/BeerModal";
import EditModal from "../RecipeDetail/EditModal";
import { del } from "@common/services/request";
import { apiEndpoints as api } from "@common/constants/urls";
import ConfirmationModal from "../../../common/components/ConfirmationModal/ConfirmationModal";
import * as beerActions from "../../../beers/actions/beerActions";
import BrewModal from "@common/components/BrewModal/BrewModal";
import * as recipeService from "../../services/recipeService";

const normalizeString = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

class RecipePage extends Component {
  state = {
    searchbar: "",
    activeFilter: "All",
    isBeerModalVisible: false,
    isEditModalVisible: false,
    isConfirmationModalVisible: false,
    beerToBeDeleted: null,
    beerToBeEdited: null,
    showBrewModal: false,
    recipeToBrew: null,
    sortOrder: "name",
    showFilterModal: false,
    abvFilter: "",
    durationFilter: "",
  };

  componentDidMount() {
    const saved = sessionStorage.getItem("personalLibraryState");
    if (saved) {
      try {
        const state = JSON.parse(saved);
        this.setState({
          searchbar: state.searchbar || "",
          activeFilter: state.activeFilter || "All",
          sortOrder: state.sortOrder || "name",
          abvFilter: state.abvFilter || "",
          durationFilter: state.durationFilter || "",
        });

        setTimeout(() => {
          if (state.scrollY) {
            window.scrollTo(0, state.scrollY);
          }
        }, 100);
      } catch (e) {
        /* ignore */
      }
    }

    const userId =
      localStorage.getItem("userId") || this.props.userInfo.user.id;
    this.props.fetchBeers(userId);

    window.addEventListener("beforeunload", this.saveScroll);
  }

  componentWillUnmount() {
    this.saveScroll();
    window.removeEventListener("beforeunload", this.saveScroll);
  }

  saveScroll = () => {
    const state = {
      searchbar: this.state.searchbar,
      activeFilter: this.state.activeFilter,
      sortOrder: this.state.sortOrder,
      abvFilter: this.state.abvFilter,
      durationFilter: this.state.durationFilter,
      scrollY: window.scrollY,
    };
    sessionStorage.setItem("personalLibraryState", JSON.stringify(state));
  };

  closeBrewModal = () =>
    this.setState({ showBrewModal: false, recipeToBrew: null });

  openBrewModalForBeer = (beerId) => {
    recipeService.getRecipes(beerId).then((res) => {
      let sortedRecipes = [...res];
      sortedRecipes.sort((a, b) => a.id - b.id);
      const brewableRecipes = sortedRecipes.filter((r) => r.brewable);

      // Default to latest brewable. If none exist, use the latest overall
      // so BrewModal can render the appropriate error.
      const latestRecipe =
        brewableRecipes.length > 0
          ? brewableRecipes[brewableRecipes.length - 1]
          : sortedRecipes[sortedRecipes.length - 1];

      this.setState({
        showBrewModal: true,
        recipeToBrew: latestRecipe,
      });
    });
  };

  handleChange = (event) => {
    const newState = this.state;
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  setFilter = (filter) => {
    this.setState({ activeFilter: filter });
  };

  filteredList = (beers) => {
    let searchterm = this.state.searchbar.toLowerCase();

    // Remove accents/diacritics in string
    searchterm = normalizeString(searchterm);

    if (beers !== null) {
      let result = beers;

      if (this.state.activeFilter !== "All") {
        result = result.filter((beer) =>
          beer.style?.name
            ?.toLowerCase()
            .includes(this.state.activeFilter.toLowerCase()),
        );
      }

      if (this.state.abvFilter) {
        if (this.state.abvFilter === "<5")
          result = result.filter((b) => b.abv < 5);
        else if (this.state.abvFilter === "5-8")
          result = result.filter((b) => b.abv >= 5 && b.abv <= 8);
        else if (this.state.abvFilter === "8-10")
          result = result.filter((b) => b.abv > 8 && b.abv <= 10);
        else if (this.state.abvFilter === ">10")
          result = result.filter((b) => b.abv > 10);
      }

      if (this.state.durationFilter) {
        if (this.state.durationFilter === "<14")
          result = result.filter((b) => b.days_to_brew < 14);
        else if (this.state.durationFilter === "14-21")
          result = result.filter(
            (b) => b.days_to_brew >= 14 && b.days_to_brew <= 21,
          );
        else if (this.state.durationFilter === ">21")
          result = result.filter((b) => b.days_to_brew > 21);
      }

      return result.filter(
        (beer) =>
          !!normalizeString(beer.name.toLowerCase()).includes(searchterm) ||
          !!normalizeString((beer.style?.name || "").toLowerCase()).includes(
            searchterm,
          ) ||
          !!normalizeString((beer.abv || "").toString().toLowerCase()).includes(
            searchterm,
          ),
      );
    } else return [];
  };

  routeTo = () => {
    this.props.dispatch(push(this.props.match.url + "/new/"));
  };

  showBeerModal = () => this.setState({ isBeerModalVisible: true });

  closeBeerModal = () =>
    this.setState({ isBeerModalVisible: false, beerToBeEdited: null });

  showConfirmationModal = (beerId) =>
    this.setState({
      isConfirmationModalVisible: true,
      beerToBeDeleted: beerId,
    });

  closeConfirmationModal = () =>
    this.setState({ isConfirmationModalVisible: false });

  editBeer = (beer) =>
    this.setState({ isEditModalVisible: true, beerToBeEdited: beer });

  closeEditModal = () =>
    this.setState({ isEditModalVisible: false, beerToBeEdited: null });

  deleteBeer = async (beerID) => {
    try {
      await del(`${api.beers}${beerID}/`);
      this.props.fetchBeers(this.props.userInfo.user.id);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to delete beer:", error);
    }
  };

  updateBeer = (beer) => {
    const updatedBeers = [...this.props.beers.list];
    const index = updatedBeers.findIndex((elem) => elem.id === beer.id);
    const newStyle = {
      ...this.props.beers.list[index].style,
      id: beer.style,
      name: beer.styleName,
    };
    updatedBeers[index] = {
      ...updatedBeers[index],
      name: beer.name,
      style: newStyle,
    };
    this.setState({ isBeerModalVisible: false, beerToBeEdited: null });
    this.props.fetchBeers(this.props.userInfo.user.id);
  };

  render() {
    const { isFetching } = this.props.beers;
    const {
      activeFilter,
      searchbar,
      sortOrder,
      showFilterModal,
      abvFilter,
      durationFilter,
    } = this.state;
    const activeFiltersCount = (abvFilter ? 1 : 0) + (durationFilter ? 1 : 0);
    const beersList = this.props.beers.list || [];
    let filteredBeers = this.filteredList(beersList);

    // Sort logic
    if (sortOrder === "name") {
      filteredBeers.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (sortOrder === "-created") {
      filteredBeers.sort((a, b) => new Date(b.created) - new Date(a.created));
    } else if (sortOrder === "created") {
      filteredBeers.sort((a, b) => new Date(a.created) - new Date(b.created));
    } else if (sortOrder === "-abv") {
      filteredBeers.sort((a, b) => (b.abv || 0) - (a.abv || 0));
    } else if (sortOrder === "abv") {
      filteredBeers.sort((a, b) => (a.abv || 0) - (b.abv || 0));
    } else if (sortOrder === "-ibu") {
      filteredBeers.sort((a, b) => (b.ibu || 0) - (a.ibu || 0));
    } else if (sortOrder === "ibu") {
      filteredBeers.sort((a, b) => (a.ibu || 0) - (b.ibu || 0));
    }

    // Compute dynamic filter options based on the user's actual beer styles
    const uniqueStyles = Array.from(
      new Set(
        beersList
          .map((beer) => beer.style?.name)
          .filter((style) => style && style.trim() !== ""),
      ),
    ).sort();

    const filterOptions = ["All", ...uniqueStyles];

    return (
      <div className="beer-library">
        <div className="beer-library__header">
          <div className="container">
            <div className="row">
              <div
                className="col-xs-12 col-md-12 col-lg-10 col-lg-offset-1"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="beer-library__header-title">
                  <h2>BEERS</h2>
                  <span className="beer-library__count">
                    {this.props.beers.list ? this.props.beers.list.length : 0}{" "}
                    recipes
                  </span>
                </div>
                <Button
                  bsStyle="warning"
                  className="beer-library__add-btn"
                  onClick={this.showBeerModal}
                >
                  + NEW BEER
                </Button>
              </div>
            </div>
          </div>
        </div>

        {isFetching ? (
          <Spinner className={"center-spinner"} />
        ) : (
          <React.Fragment>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-md-12 col-lg-10 col-lg-offset-1">
                  <div className="beer-library__controls">
                    <FormGroup
                      controlId="searchForm"
                      className="beer-library__search"
                      style={{ maxWidth: "100%", width: "100%" }}
                    >
                      <div
                        className="beer-library__search-wrapper"
                        style={{ position: "relative" }}
                      >
                        <span className="ion-search beer-library__search-icon" />
                        <FormControl
                          name="searchbar"
                          type="text"
                          value={searchbar}
                          placeholder="Search recipes, styles, ingredients, or brewers"
                          onChange={this.handleChange}
                        />
                        {searchbar && (
                          <i
                            className="ion-close-round search-clear-icon"
                            onClick={() => this.setState({ searchbar: "" })}
                          />
                        )}
                      </div>
                    </FormGroup>

                    <div className="filters-sort-container">
                      <Button
                        onClick={() => this.setState({ showFilterModal: true })}
                        className={`filter-modal-btn ${activeFiltersCount > 0 ? "attention" : ""}`}
                      >
                        <i className="ion-android-options filter-icon" />{" "}
                        Filters{" "}
                        {activeFiltersCount > 0
                          ? `(${activeFiltersCount})`
                          : ""}
                      </Button>
                      <div className="sort-wrapper">
                        <span className="sort-label">Sort by:</span>
                        <FormGroup
                          controlId="sortOrderForm"
                          className="sort-form-group"
                        >
                          <FormControl
                            componentClass="select"
                            value={sortOrder}
                            name="sortOrder"
                            onChange={this.handleChange}
                            className="sort-select"
                          >
                            <option value="name">Name (A-Z)</option>
                            <option value="-ibu">IBU (High-Low)</option>
                            <option value="ibu">IBU (Low-High)</option>
                            <option value="-abv">ABV (High-Low)</option>
                            <option value="abv">ABV (Low-High)</option>
                          </FormControl>
                        </FormGroup>
                      </div>
                    </div>

                    <div
                      className="beer-library__filters"
                      style={{ marginTop: 0 }}
                    >
                      {filterOptions.map((f) => (
                        <button
                          key={f}
                          className={`filter-chip ${activeFilter === f ? "active" : ""}`}
                          onClick={() => this.setFilter(f)}
                        >
                          {f}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-md-12 col-lg-10 col-lg-offset-1">
                  <div className="beer-library__list">
                    {filteredBeers.length > 0
                      ? filteredBeers.map((beer) => (
                          <BeerCard
                            key={beer.id}
                            beer={beer}
                            editBeer={this.editBeer}
                            confirmBeerDeletion={this.showConfirmationModal}
                            brewBeer={this.openBrewModalForBeer}
                          />
                        ))
                      : !this.props.beers.isFetching &&
                        this.props.beers.list && (
                          <div
                            style={{ textAlign: "center", padding: "40px 0" }}
                          >
                            {this.props.beers.list.length === 0 ? (
                              <>
                                <img
                                  src={(__req_0.default !== undefined ? __req_0.default : __req_0)}
                                  style={{
                                    width: "40%",
                                    maxWidth: "200px",
                                    marginBottom: "20px",
                                  }}
                                  alt="No beers"
                                />
                                <h2
                                  style={{
                                    fontWeight: "normal",
                                    fontFamily: "Gotham-Bold",
                                    color: "#333",
                                  }}
                                >
                                  No beers yet, start creating!
                                </h2>
                                <Button
                                  bsStyle="warning"
                                  className="createbeer__button"
                                  onClick={this.showBeerModal}
                                  style={{ marginTop: "16px" }}
                                >
                                  + NEW BEER
                                </Button>
                              </>
                            ) : (
                              <p style={{ color: "#888", fontSize: "16px" }}>
                                No beers match your search or filter.
                              </p>
                            )}
                          </div>
                        )}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        <BeerModal
          show={this.state.isBeerModalVisible}
          hide={this.closeBeerModal}
          updateBeer={this.updateBeer}
        />
        <EditModal
          show={this.state.isEditModalVisible}
          closeEditModal={this.closeEditModal}
          beer={this.state.beerToBeEdited}
          refetchRecipes={() =>
            this.props.fetchBeers(this.props.userInfo.user.id)
          }
        />
        <ConfirmationModal
          show={this.state.isConfirmationModalVisible}
          hide={this.closeConfirmationModal}
          title="DELETE BEER"
          msg="Are you sure you want to delete this beer? This will remove all shared recipes that belong to this beer to be removed from the community page."
          action={() => this.deleteBeer(this.state.beerToBeDeleted)}
        />
        <Modal
          show={showFilterModal}
          onHide={() => this.setState({ showFilterModal: false })}
          dialogClassName="modal-mobile-bottom"
        >
          <Modal.Header closeButton>
            <Modal.Title className="modal-filter-title">
              Advanced Filters
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="filter-section-container">
              <h5 className="modal-filter-section-title">ABV (%)</h5>
              <div className="filter-chips-container">
                {[
                  { label: "< 5%", value: "<5" },
                  { label: "5 - 8%", value: "5-8" },
                  { label: "8 - 10%", value: "8-10" },
                  { label: "> 10%", value: ">10" },
                ].map((opt) => (
                  <div
                    key={opt.value}
                    onClick={() =>
                      this.setState({
                        abvFilter: abvFilter === opt.value ? "" : opt.value,
                      })
                    }
                    className={`filter-chip-selectable ${abvFilter === opt.value ? "attention" : ""}`}
                  >
                    {opt.label}
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h5 className="modal-filter-section-title">Duration (Days)</h5>
              <div className="filter-chips-container">
                {[
                  { label: "< 14 days", value: "<14" },
                  { label: "14 - 21 days", value: "14-21" },
                  { label: "> 21 days", value: ">21" },
                ].map((opt) => (
                  <div
                    key={opt.value}
                    onClick={() =>
                      this.setState({
                        durationFilter:
                          durationFilter === opt.value ? "" : opt.value,
                      })
                    }
                    className={`filter-chip-selectable ${durationFilter === opt.value ? "attention" : ""}`}
                  >
                    {opt.label}
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({ abvFilter: "", durationFilter: "" })
              }
              className="btn-clear-all"
            >
              Clear All
            </Button>
            <Button
              onClick={() => this.setState({ showFilterModal: false })}
              className="btn-apply-filters"
            >
              Apply
            </Button>
          </Modal.Footer>
        </Modal>
        <BrewModal
          show={this.state.showBrewModal}
          handleClose={this.closeBrewModal}
          selectedRecipe={this.state.recipeToBrew}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ auth, userInfo, beers }) => {
  return {
    auth,
    userInfo,
    beers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBeers: (brewerID) => dispatch(beerActions.fetchBeers(brewerID)),
  };
};

RecipePage.propTypes = {
  auth: PropTypes.object,
  userInfo: PropTypes.object,
  match: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipePage);
